import React, { useEffect, useState, useContext } from 'react';
// import {CardActions,Card,CardTitle,CardText,Button} from 'react-md';
//CSS Import
import '../../css/SplashScreen.css'
import { AppProperties, Logout } from '../../common/functions';
import ApiRequestService from '../../components/ApiRequestService';
import { Card, CardContent, Typography, Button } from '@mui/material';
import { CardTitle } from 'react-md';
import LoadingSpinner from '../../components/LoadingSpinner';
import confetti from "../../images/png/confetti.png";
import { AppContext } from '../../AppContext';
import RegisterAnonymousUser from '../../SF/SFPages/SFTakequiz/components/RegisterAnonymousUser';

const practiceCompleted = function (props) {
    const appProperties = AppProperties();

    const queryParams = new URLSearchParams(location.search);
    const quizID = queryParams.get('quizID');
    const sectionID = queryParams.get('sectionID');
    const courseID = queryParams.get('courseID');
    const quizName = queryParams.get('quizName');

    const [showGoToAnalytics, setShowGoToAnalytics] = useState(false);
    const [endSplashScreen, setEndSplashScreen] = useState("");
    const [loading, setLoading] = useState(false);

    const appContext = useContext(AppContext);

    const checkIfThisStudentsCourseSectionEnabled = () => {
        ApiRequestService({
            method: 'get',
            url: '/getStudentCourseSectionPracticeEnabled',
        }).then(res => {
            console.debug("res ==========", res);
            if (res && res.data) {
                if (res.data.data !== undefined && res.data.data !== null) {
                    setShowGoToAnalytics(res.data.data)
                }
            }
        });
    }

    const getEndSplashScreen = () => {
        setLoading(true);
        let payload = {
            'quiz_id': parseInt(quizID),
            'section_id': parseInt(sectionID),
        };
        ApiRequestService({
            method: 'post',
            url: '/getEndSplashScreen',
            data: payload
        }).then(res => {
            if (res && res.data) {
                if (res.data.data !== undefined && res.data.data !== null) {
                    let endSplashScreenText = res.data.data.end_splash_screen
                         try {
                            var altSplashText = res.data.data.alt_end_splash_screen
                            altSplashText = altSplashText.replace(/\n/ig, ' ')
                            //finding number of time image present
                            var altSplashTextCount = altSplashText.split(';').length
                            var imgTagCount = endSplashScreenText.split('<img').length - 1
                            if ((altSplashTextCount / 2) == imgTagCount) {
                                if (imgTagCount >= 1) {
                                        var altSplashTextArr = altSplashText.split(';');
                                        var lastPosOfImg = 0
                                        for (var i = 0; i <= altSplashTextArr.length - 1; i = i + 2) {
                                        lastPosOfImg = endSplashScreenText.indexOf("<img", lastPosOfImg)
                                        lastPosOfImg = lastPosOfImg + 4
                                        var b = "  title =\"" + altSplashTextArr[i] + "\"  alt =\"" + altSplashTextArr[i + 1] + "\" "
                                        var output = [endSplashScreenText.slice(0, lastPosOfImg), b, endSplashScreenText.slice(lastPosOfImg)].join('');
                                        endSplashScreenText = output
                                        setEndSplashScreen(endSplashScreenText);
                                    }
                                }
                            }else {
                                 setEndSplashScreen(endSplashScreenText);
                            }
                            // console.debug(imgTagCount, "position of image    ", tempSplashScreen, " ")
                        } catch (e) {
                            console.debug("ERROR in splash screen Alt Text  ", e)
                        }
                }
            }
        }).finally(() => {
            setLoading(false);
        });
    }


    useEffect(() => {
        checkIfThisStudentsCourseSectionEnabled()
        if (parseInt(quizID) && parseInt(sectionID) && parseInt(sectionID) > 0 && parseInt(quizID) > 0 ) {
            getEndSplashScreen();
        }
    }, [])

    function QuizList() {

        props.handleRoute("/");

    }

    function viewAnalytics() {

        let performanceURL = `/performanceAnalytics?tabName=byassignments&quizID=${quizID}`
        if (sectionID === "NaN" || sectionID === '-1') {
            performanceURL = `/performanceAnalytics?tabName=sets&quizID=${quizID}`; // My Sets Tab
        }

        console.debug("performanceURL>>>", performanceURL)


        props.handleRoute(performanceURL);
    }

    const handleLogout = () => {
        Logout();
        window.location.href = `${window.location.protocol}//${window.location.host}`;
    }

    // console.debug("appProperties.currentUserData", appProperties.currentUserData)
    
    const getContent = () => {
        let content = "";

        if (appProperties.currentUserData && appProperties.currentUserData.isAnonymous) {
            content = (
                <React.Fragment>
                        <Typography className='mt-4 mb-2' fontSize={20} fontWeight={500}>
                            Congratulations!
                        </Typography>
                        <Typography className='mt-2' fontSize={20} fontWeight={500}>
                            Would you like to register and track your progress?
                            <div>
                                <small>
                                    (Create an account to save your progress, track achievements, and access personalized analytics)
                                </small>
                            </div>
                        </Typography>
                        <div className='mt-4'>
                            <RegisterAnonymousUser 
                                btnContent={"Register & Track Progress"}
                            />
                        </div>
                    </React.Fragment>
            )
        } else {
            if (endSplashScreen) {
                content = (
                    <div className="sf-end-splash-screen-container">
                        <div style={{overflow:"auto"}} className='sf-end-splash-screen-text' dangerouslySetInnerHTML={{ __html: endSplashScreen }} />
                    </div>
                )
            } else {
                content = (
                    <React.Fragment>
                        <Typography className='mt-4' fontSize={20} fontWeight={500}>
                            Congratulations! {props.globalProperties.currentUserData.GivenName} You have completed the assignment - {quizName}
                        </Typography>
                        <Typography className='mt-0' fontSize={20} fontWeight={500}>
                            You are now a Student Ninja!
                        </Typography>
                    </React.Fragment>
                )
            }
        }

        return content;
    }

    return (
        <div
            className='h-100 w-100 position-relative d-flex justify-content-center align-items-center'
            style={{
                zIndex: 999,
            }}
        >
            <Card className='position-relative' style={{
                width: '100%',
                height: '100%'
            }}>
            {loading ? <LoadingSpinner /> : 
                <CardContent className='h-100 d-flex flex-column justify-content-center align-items-center text-align-center'>
                    <div><img src={confetti} /></div>
                    <Typography className='mt-3' color={"primary"} variant='h4' fontWeight={500}>
                        YOU DID IT!
                    </Typography>
                    {getContent()}
                    {/* {
                        endSplashScreen ?
                           
                                    <div className="sf-end-splash-screen-container">
                                        
                                        <div style={{overflow:"auto"}} className='sf-end-splash-screen-text' dangerouslySetInnerHTML={{ __html: endSplashScreen }} />
                                    </div>
                            :
                            <>
                                <Typography className='mt-4' fontSize={20} fontWeight={500}>
                                    Congratulations!
                                    {appProperties.currentUserData.isAnonymous ? ` You have completed the assignment - ${quizName}` :
                                        ` ${props.globalProperties.currentUserData.GivenName}`
                                    }
                                </Typography>
                                {appProperties.currentUserData.isAnonymous ? null :
                                    <Typography className='mt-0' fontSize={20} fontWeight={500}>
                                        You are now a Student Ninja!
                                    </Typography>
                                }
                            </>
                    } */}
                    {/* {appProperties.currentUserData.isAnonymous ? null :
                        <Button variant='contained' className='mt-4' onClick={QuizList}>Home</Button>
                    } */}
                    {appProperties.enableLTI || appProperties.isLTIStudent ? null : (
                        appProperties.currentUserData.isAnonymous ? <Button variant='outlined' className='mt-4' onClick={handleLogout}>Close</Button> : <div>
                            <Button variant='contained' className='mt-4' onClick={QuizList}>Home</Button>
                            {/* <Button  variant='contained' className='mt-5' onClick={viewAnalytics}>View Analytics</Button> */}
                        </div>
                    )}
                </CardContent>
             }
            </Card>
        </div>
    )

    return <Card className="md-block-centered splashScreencontainer">
        <CardTitle className="splashCardTitle" title={"Congratulations! You are now a student ninja!"} />
        {showGoToAnalytics ?
            <React.Fragment>
                {/* <CardText>
                            <h5 className='text-center p-0'>You can view your performance analytics and set up additional optional practice.</h5>
                        </CardText> */}

                <CardActions centered>
                    <Button flat primary swapTheming onClick={QuizList}>Home</Button>
                </CardActions>
            </React.Fragment>
            : null}

    </Card>


};

// practiceCompleted.propTypes = {
//     title: PropTypes.string.isRequired,
//     splashText: PropTypes.string,
//     onStartClick:PropTypes.func.isRequired,
// };

export default practiceCompleted;
